
// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const reportTypeApi = baseApi.injectEndpoints({

  credentials: "include",
  endpoints: (builder) => ({
    addReportType: builder.mutation({
      query: (data) => {
        return {
          url: "report-type",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateReportType: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `report-type/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteReportType: builder.mutation({
      query: (slug) => {
        return {
          url: `report-type/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllReportType: builder.query({
      query: ({ limit, skip }) => {
        return {
          url: `report-type?limit=${limit}&skip=${skip}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddReportTypeMutation,
  useUpdateReportTypeMutation,
  useDeleteReportTypeMutation,
  useGetAllReportTypeQuery,
} = reportTypeApi;
